import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/stufen',
    name: 'Stufen',
    component: () => import('../components/Stufen-allgemein.vue'),
  },
  {
    path: '/team',
    name: 'Team',
    component: () => import('../components/leitungs-team.vue'),
  },
  {
    path: '/mitmachen',
    name: 'Mitmachen',
    component: () => import('../components/mitmachen-seite.vue'),
  },
  {
    path: '/kontakt',
    name: 'Kontakt',
    component: () => import('../components/kontakt-seite.vue'),
  },
    {
    path: '/spenden',
    name: 'Spenden',
    component: () => import('../components/spenden-seite.vue'),
  },
  {
    path: '/impressum',
    name: 'Impressum',
    component: () => import('../components/impressum-seite.vue'),
  },
    {
    path: '/datenschutz',
    name: 'Datenschutz',
    component: () => import('../components/datenschutz-seite.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
